(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('bottomRightSchema', bottomRightSchemaInject);

  /** @ngInject */
  function bottomRightSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/doserSubSystem-resized.svg',
      controller: BottomRightSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function BottomRightSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'vent.highFloat', 'vent.lowFloat', 'value.pressure',
        'value.motor', 'value.motorError', 'value.motorVibroError',
        'value.motorDoser', 'value.motorDoserError'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2] ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[5]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[4] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }

        if (newValue[6]) {
          vm.motorVibro = schemaUtils.COLORS.error;
        } else {
          vm.motorVibro = schemaUtils.COLORS.notWorking;
        }

        if (newValue[8]) {
          vm.motorDoser = schemaUtils.COLORS.error;
        } else {
          vm.motorDoser = newValue[7] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();
